module.exports = __webpack_public_path__ + "static/media/la1.5eeb2fa8.png";